<!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <h5 class="card-title">Request Details</h5>
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ ApproveRequest?.reference }}</p>
            </div>

            <div class="col">
              <label><b>Function</b></label>
              <p>{{ ApproveRequest?.departmentName }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Location</b></label>
              <p>{{ ApproveRequest?.locationName }}</p>
            </div>

            <div class="col">
              <label><b>Cost Center</b></label>
              <p>{{ ApproveRequest?.costCenterName }}</p>
            </div>
          </div>
        </div>

        <hr>

        <!-- Non Editable View -->
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ ApproveRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Contract Duration </b></label>
              <p>{{ ApproveRequest?.contractDuration }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Expected Start Date</b></label>
              <p>{{ ApproveRequest?.expectedStartDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Number of Staff</b></label>
              <p>{{ ApproveRequest?.noOfStaff }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Budget Cost</b></label>
              <p>{{ ApproveRequest?.budgetCost | currency:"NGN":"symbol-narrow" }}</p>
            </div>

            <div class="col">
              <label><b>Requested By</b></label>
              <p>{{ ApproveRequest?.createdBy }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Request Description</b></label>
              <p>{{ ApproveRequest?.description }}</p>
            </div>

            <div class="col">
              <label><b>Request Justification</b></label>
              <p>{{ ApproveRequest?.justification }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Required Qualification & Experience</b></label>
              <p>{{ ApproveRequest?.qualification }}</p>
            </div>
            <div class="col">
              <label><b>Mode Of HeadCount</b></label>
              <p>{{ ApproveRequest?.modeOfHeadCount }}</p>
            </div>
              
           
          </div>
          <div class="row">

            <div class="col" *ngIf="ApproveRequest?.axiom">
              <label *ngIf="ApproveRequest?.axiom != ''"><b>Axiom</b></label>
              <p>{{ ApproveRequest?.axiom }}</p>
            </div>

            <div class="col" *ngIf="isHrbp && !ApproveRequest?.axiom">
                <div class="form-group">
                  <label for="selectedAxiom"><b>Select Axiom</b></label>
                  <select class="form-control" required [(ngModel)]="axiomId" name="axiomId"
                    id="axiomId"  (ngModelChange)="onChangeAxiom($event)">
                    <option value="">-- Select Axiom --</option>
                    <option [value]="axiom.id" *ngFor="let axiom of axioms">{{axiom.name}}
                    </option>
                  </select>
                  
                </div>
              </div>

            
             <div class="col">
              <label><b>Request Type</b></label>
              <p>{{ ApproveRequest?.renewalOrNew}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label><b>Comment</b></label>
              <input name="" id="" [(ngModel)]="Comment" class="form-control" placeholder="">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
   <!-- Approvals -->
   <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Approved By
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of RequestApprovals">

            <td>{{approval.approvedBy}}</td>
            <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!RequestApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
  </div>
  <ng-template #footerTpl>
    <div style="float: right" class="d-print-none">
    
      <a  (click)="approveContract()"> 
        <span style="margin-right: 8px;" class="btn btn-primary">
            Approve
        </span>
    </a> 
    
    <a   (click)="rejectContract()"> 
      <span style="margin-right: 8px;"class="btn btn-danger">
          Reject
      </span>
  </a> 
      
      
      <button class="btn btn-light" style="margin-right: 8px;" (click)="close()">Close</button>
    </div>
  </ng-template>

</nz-drawer>
<!-- Drawer -->

<div class="content-wrapper">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title"> Pending Approvals</h4>
          <div class="table-responsive pt-3" *ngIf="Contracts?.length">
            <table class="table table--striped table-hover">
              <thead>
                <tr>
                  <th>
                    Reference
                  </th>
                  <th>
                    Request Date
                  </th>
                  <th>
                    Request Description
                  </th>
                  <th>
                    Created By
                  </th>
                  <th *ngIf="showFunctionColumn">
                    Function
                  </th>
                  <th>
                    Location
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of Contracts" (click)="open(data)" class="clickable">
                  <td>{{data.reference}}</td>

                  <td>{{data.createdDate | date: 'dd MMMM yyyy'}}</td>

                  <td>{{data.description.substring(0,50)}} ...</td>

                  <td>{{data.createdBy}}</td>

                  <td *ngIf="showFunctionColumn">{{data.departmentName}}</td>

                  <td>{{data.locationName}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="!Contracts?.length" style="text-align: center; padding: 18px;">
            <h4 style="color: rgba(128, 128, 128, 0.741); ">You have no request pending approval</h4>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>